import * as React from 'react';

import TimeCommitmentEffortText from 'bundles/learner-progress/components/item/TimeCommitmentEffortText';
import type { Item } from 'bundles/learner-progress/types/Item';
import { getIsAssignmentPartForSplitPeer, getIsMentorGraded } from 'bundles/learner-progress/utils/Item';

import _t from 'i18n!nls/learner-progress';

type PropsFromCaller = {
  item: Item;
  className: string;
};

/**
 * The effort text for peer review is substantially more complex,
 * because there are more actionable states for the user.
 * Split into its own component for ease of use.
 */
export const PeerReviewEffortText = ({ item, className, ...rest }: PropsFromCaller) => {
  if (!getIsAssignmentPartForSplitPeer(item) && !getIsMentorGraded(item)) {
    return null;
  }

  if (item.isPeerAssignmentFailed) {
    return (
      <span {...rest} className={className}>
        {_t('Submitted')}
      </span>
    );
  } else if (item.isPeerAssignmentWaitingForEvaluation) {
    return (
      <span {...rest} className={className}>
        {_t('Grading in progress')}
      </span>
    );
  } else if (item.isCompleted && !item.isCombinedItemCompleted) {
    return (
      <span {...rest} className={className}>
        {_t('You must review more classmates')}
      </span>
    );
  }

  return <TimeCommitmentEffortText timeCommitment={item.timeCommitment} className={className} {...rest} />;
};

export default PeerReviewEffortText;
